function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import React from 'react';
import { Registry } from './utils';
export class PartRegistry extends Registry {
    constructor(...args){
        super(...args), // return created react element from component with minimal part config
        _define_property(this, "createElement", (name, ...cfg)=>this.get(name) ? /*#__PURE__*/ React.createElement(this.get(name), {
                type: name,
                ...cfg
            }) : `missing ${name}`);
    }
}
// setup connected versions of Part components
export const Parts = new PartRegistry({
    namespace: 'Part',
    connect: true,
    components: {}
});
// more
export const WikiTemplates = {};
export const JobTemplates = {} // greppable name
;
export const DashboardPanels = {};
export const NodeMenuItems = {};
